import React, { useState } from 'react'
import SearchBar from '../../../components/SearchBar'
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Button } from '@mui/material';
import AddIcon from "@mui/icons-material/Add";
import SwitchToggle from '../../../components/SwitchToggle';
import AddFikraStep from '../../../Modals/addFikraStep';
import ViewFikraStep from '../../../Modals/viewFikraStep';
import DragHandleIcon from '@mui/icons-material/DragHandle';
function CreateFikraForm() {

  const steps = [
    {
      id: 1,
      questionHeading: "What are you passionate about?",
      questionType: "Checkbox",
      status: "Enable",
    },
    {
      id: 2,
      questionHeading: "What skills do you have?",
      questionType: "Checkbox",
      status: "Enable",
    },
    {
      id: 3,
      questionHeading: "What's your startup budget?",
      questionType: "Budget",
      status: "Enable",
    },
    {
      id: 4,
      questionHeading: "How much time can you commit?",
      questionType: "Radio",
      status: "Enable",
    },
    {
      id: 5,
      questionHeading: "What's your business experience?",
      questionType: "Radio",
      status: "Enable",
    },
    {
      id: 6,
      questionHeading: "Which emirate will you operate in?",
      questionType: "Radio",
      status: "Enable",
    },
    {
      id: 7,
      questionHeading: "Have a Specific Business Idea?",
      questionType: "Textarea",
      status: "Enable",
    },
  ];

  const [openModal, setOpenModal] = useState(false);
  const [openModal1, setOpenModal1] = useState(false);

  const handleCloseModal = () => setOpenModal(false);
  const handleCloseModal1 = () => setOpenModal1(false);

  return (
    <>
      <div className="main_title d_flex" >
        <h1>Fikra Lab – Create Form</h1>
        <div className="right_s">
          <h3>Enable/Disable Fikra Lab</h3>
          <SwitchToggle defaultChecked={true} />
        </div>
      </div>

      <div className="cards">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={""}
              setDebouncedSearchTerm={() => { }}
              placeholder="Search..."
            />
          </div>
          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => setOpenModal(true)}>
              <AddIcon /> Add New Step
            </Button>
          </div>
        </div>

        <TableContainer className="table_container">
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Step No.</TableCell>
                <TableCell>Question Heading</TableCell>
                <TableCell>Question Type</TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Action</TableCell>
                <TableCell>Position</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {steps.map((item) => (
                <TableRow hover key={item.id}>
                  <TableCell>Step {item.id}</TableCell>

                  <TableCell>
                    <strong>{item.questionHeading}</strong>
                  </TableCell>

                  <TableCell>{item.questionType}</TableCell>

                  <TableCell>
                    <SwitchToggle defaultChecked={item.status === "Enable"} />
                  </TableCell>

                  <TableCell>
                    <div className="table_actions v2">
                      <IconButton onClick={() => setOpenModal1(true)}>
                        <img
                          src="/static/images/eye_icon.svg"
                          alt="View"
                        />
                      </IconButton>
                      <IconButton onClick={() => setOpenModal(true)}>
                        <img
                          src="/static/images/edit2_icon.svg"
                          alt="Edit"
                        />
                      </IconButton>
                      <IconButton>
                        <img
                          src="/static/images/trash2_icon.svg"
                          alt="Delete"
                        />
                      </IconButton>
                    </div>
                  </TableCell>
                  <TableCell >
                    <DragHandleIcon style={{cursor:"pointer"}}/>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>

      <AddFikraStep open={openModal} onClose={handleCloseModal} setOpen={setOpenModal} />
      <ViewFikraStep open={openModal1} onClose={handleCloseModal1} setOpen={setOpenModal1} />
    </>
  )
}

export default CreateFikraForm